import { Injectable } from '@angular/core';
import { HttpClient2 } from './http-client.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class GuiaEvidenciaService {
  ciaId : string;
  usuId: number;

  constructor(private http : HttpClient2) {

    let currentUser  = JSON.parse(localStorage.getItem("currentUser"));
    this.ciaId = "/"+currentUser.compania.companiaId;
    this.usuId = currentUser.usuarioId;

  }

  /**
   * Modifica una guía con evidencia
   * @param guiaData Datos de la guía (puede ser objeto o FormData)
   * @param guiaEvidenciaId ID de la guía
   * @param file Opcional: Archivo a adjuntar
   */
  modificar(guiaData: any, guiaEvidenciaId: number, file?: File): any {
    // Si se proporciona un archivo, crear FormData
    const formData = new FormData();

    const jsonBlob = new Blob([JSON.stringify(guiaData)], {
      type: 'application/json'
    });
    formData.append('guiaEvidencia', jsonBlob);
    
    if (file) {
      formData.append('image', file, file.name);
    }

    let httpOptions: any = {};
    httpOptions.noUseContent = false;

    return this.http.modificar('/guias-evidencia/' + guiaEvidenciaId, formData, httpOptions)
      .map(result => result)
      .catch(error => {
        console.error('Error al modificar guía:', error);
        throw error;
      });
  }
}
